import axios from 'axios';

export enum TipoCalculoTabelaPreco {
  AcrescimoSobreVenda = 0,
  DescontoSobreVenda = 1,
  MarkupSobreCusto = 2,
  MargemLucro = 3,
  ValorFixo = 4,
}

export interface RegraEspecialDto {
  produtoId: string;
  tipoCalculo: TipoCalculoTabelaPreco;
  percentual: number;
}

// Regra como vem do detalhe (inclui dados do produto p/ exibição)
export interface RegraEspecialDetalhe extends RegraEspecialDto {
  produtoCodigo: number;
  produtoDescricao?: string;
  produtoCodigoBarras?: string;
}

export interface TabelaPrecoListItem {
  id: string;
  codigo: number;
  nome: string;
  ativa: boolean;
  tipoCalculo: TipoCalculoTabelaPreco;
  percentual: number;
  qtdProdutos: number;
}

export interface TabelaPrecoDetalhe extends TabelaPrecoListItem {
  empresasIds: string[];
  regrasEspeciais: RegraEspecialDetalhe[];
}

export interface SalvarTabelaPrecoDto {
  nome: string;
  ativa: boolean;
  tipoCalculo: TipoCalculoTabelaPreco;
  percentual: number;
  empresasIds: string[];
  regrasEspeciais: RegraEspecialDto[];
}

export const tabelaPrecoService = {
  /**
   * Lista tabelas de preço com filtro opcional
   */
  async listar(termo?: string): Promise<TabelaPrecoListItem[]> {
    const response = await axios.get<TabelaPrecoListItem[]>('/api/tabela-preco', {
      params: { termo }
    });
    return response.data;
  },

  /**
   * Obtém uma tabela de preço específica
   */
  async obter(id: string): Promise<TabelaPrecoDetalhe> {
    const response = await axios.get<TabelaPrecoDetalhe>(`/api/tabela-preco/${id}`);
    return response.data;
  },

  /**
   * Cria uma nova tabela de preço
   */
  async criar(data: SalvarTabelaPrecoDto): Promise<{ id: string; codigo: number }> {
    const response = await axios.post<{ id: string; codigo: number }>('/api/tabela-preco', data);
    return response.data;
  },

  /**
   * Altera uma tabela de preço existente
   */
  async alterar(id: string, data: SalvarTabelaPrecoDto): Promise<void> {
    await axios.put(`/api/tabela-preco/${id}`, data);
  },

  /**
   * Remove uma tabela de preço
   */
  async remover(id: string): Promise<void> {
    await axios.delete(`/api/tabela-preco/${id}`);
  },
};
